import { Component, inject } from '@angular/core';
import { NoFoundSvgIconComponent } from '@components/svg-icons/no-found-svg-icon/no-found-svg-icon.component';
import { MenuActions } from '../../shared/states/menu_actions';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-no-found',
  imports: [NoFoundSvgIconComponent, TranslocoPipe],
  templateUrl: './no-found.component.html',
  styleUrl: './no-found.component.css',
})
export class NoFoundComponent {
  private menuActions = inject(MenuActions);
  goHome() {
    this.menuActions.goHome();
  }
}
